/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TeachingTypeEnum,
    TeachingTypeEnumFromJSON,
    TeachingTypeEnumFromJSONTyped,
    TeachingTypeEnumToJSON,
} from './TeachingTypeEnum';

/**
 * 
 * @export
 * @interface SubjectContent
 */
export interface SubjectContent {
    /**
     * 
     * @type {string}
     * @memberof SubjectContent
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof SubjectContent
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubjectContent
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SubjectContent
     */
    subjectId?: string;
    /**
     * 
     * @type {number}
     * @memberof SubjectContent
     */
    nrCrt?: number;
    /**
     * 
     * @type {string}
     * @memberof SubjectContent
     */
    content?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectContent
     */
    hoursNumber?: number;
    /**
     * 
     * @type {TeachingTypeEnum}
     * @memberof SubjectContent
     */
    teachingType?: TeachingTypeEnum;
}

export function SubjectContentFromJSON(json: any): SubjectContent {
    return SubjectContentFromJSONTyped(json, false);
}

export function SubjectContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'nrCrt': !exists(json, 'nrCrt') ? undefined : json['nrCrt'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'hoursNumber': !exists(json, 'hoursNumber') ? undefined : json['hoursNumber'],
        'teachingType': !exists(json, 'teachingType') ? undefined : TeachingTypeEnumFromJSON(json['teachingType']),
    };
}

export function SubjectContentToJSON(value?: SubjectContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'subjectId': value.subjectId,
        'nrCrt': value.nrCrt,
        'content': value.content,
        'hoursNumber': value.hoursNumber,
        'teachingType': TeachingTypeEnumToJSON(value.teachingType),
    };
}

